import * as React from 'react';

const Clipboard = require('clipboard');

export default function ClipboardCopy(props: {
    text?: string;
    getText?: () => string;
    isButtonWithGlyph?: boolean;
    caption?: string;
    onClick?(): void;
}) {
    const triggerRef = React.useRef(null);
    const clipboard = React.useRef<any>(null);

    React.useEffect(() => {
        clipboard.current = new Clipboard(triggerRef.current, {
            text: () => {
                if (props.getText != null) {
                    return props.getText();
                }

                return props.text;
            }
        });

        return () => {
            clipboard.current.destroy();
        };
    }, []);

    const handleOnClick = () => {
        if (typeof props.onClick === 'function') {
            props.onClick();
        }
    };

    if (props.isButtonWithGlyph) {
        return (
            <div className="clipboard-copy">
                <button className="btn btn-xs btn-default copy-button" ref={triggerRef} onClick={handleOnClick}>
                    {'Copy'}
                    <span className="glyphicon glyphicon-copy"></span>
                </button>
            </div>
        );
    } else {
        return (
            <button className="btn btn-default" ref={triggerRef} onClick={handleOnClick}>
                {props.caption || 'Copy'}
            </button>
        );
    }
}
